import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { useAuthState } from 'src/context';
import axios from 'src/axios';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#ffffff', //rgb(247 250 252)
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    paddingTop: 20,
    overflowY: 'none'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      // paddingLeft: 256
    },
    [theme.breakpoints.up('sm')]: {
      // paddingLeft: 240
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.down('md')]: {
      paddingRight: '2%'
    },
    padding: '0 0.2%',
    marginTop: -20
  }
}));

const DashboardLayout = () => {
  const { token } = useAuthState();
  const navigate = useNavigate();
  useEffect(() => {
    axios({
      method: 'get',
      url: '/token',
      headers: { 'x-access-token': token }
    }).then(res => {
      if (res.status !== 200) navigate('/login', { replace: true });
    });
  }, []);
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = React.useState(false);

  return (
    <>
      <div className={classes.root}>
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
